import React, { useEffect, useState } from 'react';
import {  useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import '../assets/css/incomingcallpage.css'
function generateLetterImage(letter) {
    // Create a canvas element
    const canvas = document.createElement('canvas');
    canvas.width = 100; // Set width
    canvas.height = 100; // Set height

    // Get 2D context
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#53a9e5'; // Set background color
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.fillStyle = '#ffffff'; // Set text color
    ctx.font = '48px Arial'; // Set font size and family
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(letter.toUpperCase(), canvas.width / 2, canvas.height / 2); // Draw letter

    return canvas.toDataURL(); // Get image as data URL
}

const Incomingcallscreen = ({ onAnswer, onDecline, leadname, leadnumber }) => {
    const [caller_name, setCallerName] = useState('')
    const [caller_number, setCallerNumber] = useState('')
    const caller_insight = useSelector((state) => state.callerinsight);
      const config_api = JSON.parse(localStorage.getItem('config'))
           const numberMask = JSON.parse(localStorage.getItem('number_mask'));
     const userPermission = config_api.projects[0].userPermission;
    useEffect(() => {
        setCallerName(caller_insight.ticket_name)
        setCallerNumber(caller_insight.ticket_number)
    }, [caller_insight])



    const firstLetter = leadname.charAt(0).toUpperCase();
    const letterImage = generateLetterImage(firstLetter);

    
    const maskPhoneNumber = (phoneNumber) => {
          if (!phoneNumber) return phoneNumber;
        const maskedNumber = phoneNumber.slice(0, -4).padEnd(phoneNumber.length, 'X');
        return maskedNumber;
    };

    return (
        <div className="incoming-call-container">

            <div className="incoming-call-top-container">
                <div className='calltye-header'>Incoming call</div>
                {/* <img src={letterImage} alt={firstLetter} className="letter-image" /> */}
                <div className="incomingcaller-info">
                    <div>{caller_name}</div>
                    <div>{ numberMask ? maskPhoneNumber(caller_number):(caller_number)}</div>
                </div>

                <div className="call-actions">
                    <div className="answer-button">
                        <button onClick={onAnswer} className="animate-answer" >
                            <FontAwesomeIcon icon={faPhone} />
                        </button>
                    </div>

                    <div className="decline-button">
                        <button onClick={onDecline}>
                            <FontAwesomeIcon icon={faPhone} />
                        </button>
                    </div>

                </div>

            </div>

            <div className='incoming-call-bottom-container'>

                <div className='call-info-title'> Caller Insight </div>

                {caller_insight.statuscode == 200   ? (
                    <div className='ib-call-info'>
                        <div className='ib-call-info-data-container'>
                            <div>Ticket Id</div>
                            <div>{caller_insight.ticket_id}</div>
                        </div>

                        <div className='ib-call-info-data-container'>
                            <div>Category</div>
                            <div>{caller_insight.category}</div>
                        </div>
{/* 
                        <div className='ib-call-info-data-container'>
                            <div>Created At</div>
                            <div>{caller_insight.created_at}</div>
                        </div> */}
                         
                        <div className='ib-call-info-data-container'>
                            <div>Existing Ticket Count</div>
                            <div>{caller_insight.count}</div>
                        </div>

                    </div>
                ) : (
                    <div className='insight-nodata'>No data</div>
                )}

{/* 
                <div className='ib-call-info'>
                 
                  <div className='ib-call-info-data-container'>
                    <div>Ticket Id</div> 
                    <div>1234</div>
                  </div>

                  <div className='ib-call-info-data-container'>
                    <div>Owner Name</div> 
                    <div>Pandi</div>
                  </div>

                  <div className='ib-call-info-data-container'>
                    <div>Ticket Status</div> 
                    <div>Open</div>
                  </div>


                  
                </div> */}


            </div>

                    </div>
    );
};

export default Incomingcallscreen;

